import { useParams } from "react-router-dom"
import { Gallery, AboutRoom } from "../components";
import { comfortRoomDetails, comfortPlusRoomDetails, duplexRoomDetails } from "../data/RoomData";
import { useEffect, useState } from "react";

function useIsLandscape() {
    const [isLandscape, setIsLandscape] = useState(
        window.matchMedia("(orientation: landscape)").matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia("(orientation: landscape)");

        const handler = (e) => setIsLandscape(e.matches);

        mediaQuery.addEventListener("change", handler);

        return () => mediaQuery.removeEventListener("change", handler);
    }, []);

    return isLandscape;
}

export const RoomDetails = () => {
    const params = useParams();

    let selectedRoomDetails;
    switch (params.roomType) {
        case "Comfort":
            selectedRoomDetails = comfortRoomDetails
            break;
        case "Comfort Plus":
            selectedRoomDetails = comfortPlusRoomDetails
            break;
        case "Duplex":
            selectedRoomDetails = duplexRoomDetails
            break;
        default:
            selectedRoomDetails = []
    }

    return (
        <main>
            <div className="bg-textColor">
                <h1 className="text-center text-white p-4 text-4xl select-none uppercase">{params.roomType}</h1>
            </div>
            {
                <div className="m-2">
                    <video src={selectedRoomDetails[0].roomVideo} className={`w-full ${useIsLandscape() ? "h-[90vh]" : "h-full"}`} autoPlay loop muted playsInline>
                    </video>
                </div>
            }
            <div className="flex gap-2 xl:justify-center max-xl:flex-col overflow-hidden max-xl:items-center">
                <Gallery images={selectedRoomDetails[0].images} />
                < AboutRoom roomDetail={selectedRoomDetails} />
            </div>
        </main>
    )
}